import { render, staticRenderFns } from "./ReinspectionView.vue?vue&type=template&id=4b28a588&scoped=true"
import script from "./ReinspectionView.vue?vue&type=script&lang=js"
export * from "./ReinspectionView.vue?vue&type=script&lang=js"
import style0 from "./ReinspectionView.vue?vue&type=style&index=0&id=4b28a588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b28a588",
  null
  
)

export default component.exports